import { useEffect } from 'react';

interface SchemaInjectorProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
}

export default function SchemaInjector({ schema }: SchemaInjectorProps) {
  useEffect(() => {
    const schemas = Array.isArray(schema) ? schema : [schema];
    const scriptIds: string[] = [];

    schemas.forEach((s, idx) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-${idx}-${Date.now()}`;
      script.textContent = JSON.stringify(s);
      document.head.appendChild(script);
      scriptIds.push(script.id);
    });

    return () => {
      scriptIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [schema]);

  return null;
}